export const states = [
  { key: 'AK', text: 'AK', value: 'AK' },
  { key: 'AL', text: 'AL', value: 'AL' },
  { key: 'AR', text: 'AR', value: 'AR' },
  { key: 'AS', text: 'AS', value: 'AS' },
  { key: 'AZ', text: 'AZ', value: 'AZ' },
  { key: 'CA', text: 'CA', value: 'CA' },
  { key: 'CO', text: 'CO', value: 'CO' },
  { key: 'CT', text: 'CT', value: 'CT' },
  { key: 'DC', text: 'DC', value: 'DC' },
  { key: 'DE', text: 'DE', value: 'DE' },
  { key: 'FL', text: 'FL', value: 'FL' },
  { key: 'FM', text: 'FM', value: 'FM' },
  { key: 'GA', text: 'GA', value: 'GA' },
  { key: 'GU', text: 'GU', value: 'GU' },
  { key: 'HI', text: 'HI', value: 'HI' },
  { key: 'IA', text: 'IA', value: 'IA' },
  { key: 'ID', text: 'ID', value: 'ID' },
  { key: 'IL', text: 'IL', value: 'IL' },
  { key: 'IN', text: 'IN', value: 'IN' },
  { key: 'KS', text: 'KS', value: 'KS' },
  { key: 'KY', text: 'KY', value: 'KY' },
  { key: 'LA', text: 'LA', value: 'LA' },
  { key: 'MA', text: 'MA', value: 'MA' },
  { key: 'MD', text: 'MD', value: 'MD' },
  { key: 'ME', text: 'ME', value: 'ME' },
  { key: 'MH', text: 'MH', value: 'MH' },
  { key: 'MI', text: 'MI', value: 'MI' },
  { key: 'MN', text: 'MN', value: 'MN' },
  { key: 'MO', text: 'MO', value: 'MO' },
  { key: 'MP', text: 'MP', value: 'MP' },
  { key: 'MS', text: 'MS', value: 'MS' },
  { key: 'MT', text: 'MT', value: 'MT' },
  { key: 'NC', text: 'NC', value: 'NC' },
  { key: 'ND', text: 'ND', value: 'ND' },
  { key: 'NE', text: 'NE', value: 'NE' },
  { key: 'NH', text: 'NH', value: 'NH' },
  { key: 'NJ', text: 'NJ', value: 'NJ' },
  { key: 'NM', text: 'NM', value: 'NM' },
  { key: 'NV', text: 'NV', value: 'NV' },
  { key: 'NY', text: 'NY', value: 'NY' },
  { key: 'OH', text: 'OH', value: 'OH' },
  { key: 'OK', text: 'OK', value: 'OK' },
  { key: 'OR', text: 'OR', value: 'OR' },
  { key: 'PA', text: 'PA', value: 'PA' },
  { key: 'PR', text: 'PR', value: 'PR' },
  { key: 'PW', text: 'PW', value: 'PW' },
  { key: 'RI', text: 'RI', value: 'RI' },
  { key: 'SC', text: 'SC', value: 'SC' },
  { key: 'SD', text: 'SD', value: 'SD' },
  { key: 'TN', text: 'TN', value: 'TN' },
  { key: 'TX', text: 'TX', value: 'TX' },
  { key: 'UT', text: 'UT', value: 'UT' },
  { key: 'VA', text: 'VA', value: 'VA' },
  { key: 'VI', text: 'VI', value: 'VI' },
  { key: 'VT', text: 'VT', value: 'VT' },
  { key: 'WA', text: 'WA', value: 'WA' },
  { key: 'WI', text: 'WI', value: 'WI' },
  { key: 'WV', text: 'WV', value: 'WV' },
  { key: 'WY', text: 'WY', value: 'WY' },
];
